module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes
  }, [_c('div', {
    staticClass: "unit-content"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    class: {
      "concentration-line": _vm.unit.type === "concentration"
    }
  }), _vm._v(" "), (_vm.unit.type === "concentration") ? _c('i', {
    staticClass: "fas fa-circle concentration-icon"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "unit-name"
  }, [_c('div', {
    staticClass: "unit-name-wrap"
  }, [_c('div', {
    staticClass: "unit-type"
  }, [_vm._v(_vm._s(_vm.unit.type))]), _vm._v("\n          " + _vm._s(_vm.label) + "\n        ")])]), _vm._v(" "), (_vm.active) ? [_c('div', {
    staticClass: "unit-level"
  }, [(_vm.level) ? _c('span', [_vm._v(_vm._s(_vm.level))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "unit-period-select"
  }, [(_vm.unit.planPeriods.length > 0) ? _c('multiselect', {
    attrs: {
      "options": _vm.unit.planPeriods,
      "track-by": "id",
      "label": "name",
      "selected-label": "",
      "deselect-label": "",
      "select-label": "",
      "placeholder": "Select Period"
    },
    model: {
      value: (_vm.period),
      callback: function($$v) {
        _vm.period = $$v
      },
      expression: "period"
    }
  }) : _c('span', [_vm._v(" ")])], 1)] : _vm._e()], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b4a5eae","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/unit_archived.vue
// module id = 1132
// module chunks = 1